import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GLOBAL_STATUS } from '../../constants/AppConstants';

/*
enum STATUS: GLOBAL_STATUS.value

IStatusTagMCProps: Object { ## required
    status: STATUS, ## GLOBAL_STATUS value to display in the tag
    actions: Array<{ label: string, onClick: () => void }> ## optional actions for the status
}

props: IStatusTagMCProps
*/

const StatusTagMC = ({ status, actions = [] }) => {
  const { t } = useTranslation('StatusTagMC');
  const statusRef = React.useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buildStatusProps = () => {
    switch (status) {
      case GLOBAL_STATUS.pending.value:
        return {
          bgColor: 'tw-bg-orange-50',
          textColor: 'tw-text-yellow-600',
          label: t('pending')
        };
      case GLOBAL_STATUS.cancelled.value:
        return {
          bgColor: 'tw-bg-red-400',
          textColor: 'tw-text-white',
          label: t('cancelled')
        };
      case GLOBAL_STATUS.sent.value:
        return {
          bgColor: 'tw-bg-green-50',
          textColor: 'tw-text-emerald-600',
          label: t('sent')
        };
      case GLOBAL_STATUS.processing.value:
        return {
          bgColor: 'tw-bg-orange-50',
          textColor: 'tw-text-orange-300',
          label: t('processing')
        };
      case GLOBAL_STATUS.in_process.value:
        return {
          bgColor: 'tw-bg-orange-50',
          textColor: 'tw-text-orange-300',
          label: t('in_process')
        };
      case GLOBAL_STATUS.failed.value:
        return {
          bgColor: 'tw-bg-red-400',
          textColor: 'tw-text-white',
          label: t('failed')
        };
      case GLOBAL_STATUS.scheduled.value:
        return {
          bgColor: 'tw-bg-orange-50',
          textColor: 'tw-text-orange-300',
          label: t('scheduled')
        };
      default:
        return {
          bgColor: 'tw-bg-gray-500',
          textColor: 'tw-text-gray-500',
          label: t('other')
        };
    }
  };
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const statusProps = buildStatusProps(status);
  const tagClassess = [
    'tw-inline-block',
    'tw-py-1',
    'tw-px-2',
    'tw-rounded-md',
    'tw-text-xs',
    'tw-font-regular',
    statusProps.bgColor,
    statusProps.textColor
  ].join(' ');

  return (
    <div className="tw-wrapper tw-relative tw-inline-block" ref={statusRef}>
      {actions.length === 0 ? (
        <span className={tagClassess}>{statusProps.label}</span>
      ) : (
        <div>
          <button type="button" className={tagClassess} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {statusProps.label}
            <span className="tw-ml-1 tw-text-xs tw-font-normal">&#x25BC;</span>
          </button>

          {isMenuOpen && (
            <div className="tw-absolute tw-border tw-border-gray-200 tw-right-0 tw-bg-white tw-shadow-md tw-rounded-md tw-mt-2 tw-z-10 tw-min-w-[max-content]">
              <ul className="tw-list-none tw-p-1 tw-m-0">
                {actions.map((action) => (
                  <li key={action.label} className="tw-my-1">
                    <button
                      type="button"
                      className="tw-w-full tw-text-left tw-py-0 tw-px-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-50 tw-rounded"
                      onClick={() => {
                        action.onClick();
                        setIsMenuOpen(false);
                      }}
                    >
                      {action.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StatusTagMC;
